import React from 'react';

import { CustomETReport} from '../../../../utils/models';
import { concatClassNames, formatTime } from '../../../../utils/utilities';
import { getETTestingColumns } from '../../../../utils/data';
import { APP_DATE_FORMAT } from '../../../../utils/constants';

import Conditional from '../../../common/conditional';
import CustomSection from '../../custom-general/custom-section';
import ParseHTML from '../../../common/ParseHTML';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import css from './style.module.scss';

interface ETReportProps extends CustomETReport {
	data: any[];
	sectionTitle: string;
	shouldDisplayOverview: boolean;
	shouldDisplayRemarks: boolean;
}

const ETReport: React.FC<ETReportProps> = (props) => {
	return (
		<CustomSection sectionTitle={props.sectionTitle}>
			<div className={css.etReport}>
				<Conditional isVisible={props.shouldDisplayOverview}>
					<div className="container-fluid overflow-hidden">
						<div className="row">
							<div className="col">
								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										NDE Technique
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.ndeTechnique}
									</div>
								</div>
							</div>

							<div className="col">
								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Material
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.material}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="container-fluid overflow-hidden">
						<div className="row">
							<div className="col">
								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Equipment
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.equipment}
									</div>
								</div>

								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Probe
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.probe}
									</div>
								</div>

								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Probe Frequency
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.probeFrequency}
									</div>
								</div>

								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Scanning Level
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.scanningLevel}
									</div>
								</div>
							</div>

							<div className="col">
								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Serial No
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.serialNo}
									</div>
								</div>

								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Serial No
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.serialNo}
									</div>
								</div>

								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Calibration Blk
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.calibrationBlk}
									</div>
								</div>

								<div className="row">
									<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
										Sensitivity
									</div>
									<div className={concatClassNames([css.etReportBody, 'col'])}>
										{props.sensitivity}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="container-fluid overflow-hidden">
						<div className="row">
							<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
								Calibration Due
							</div>
							<div className={concatClassNames([css.etReportBody, 'col'])}>
								{formatTime(props.calibrationDue, APP_DATE_FORMAT)}
							</div>
						</div>
					</div>
				</Conditional>

				<PDFTablePage data={props.data} columns={getETTestingColumns()} />

				<Conditional isVisible={props.shouldDisplayRemarks}>
					<div className="container-fluid overflow-hidden">
						<div className="row">
							<div className={concatClassNames([css.etReportHeader, 'col-4'])}>
								Remarks
							</div>
							<div className={concatClassNames([css.etReportBody, 'col'])}>
								<ParseHTML text={props.remarks} />
							</div>
						</div>
					</div>
				</Conditional>
			</div>
		</CustomSection>
	);
};

export default ETReport;
